import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import * as colors from "@mui/material/colors";
import { Category } from "./category";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  searchByCategoryStart,
  searchNearByStart,
  suggestionFetchStart,
  setServiceName,
} from "../../store/map/reducer";

export const NearBy = ({ setActiveTab = () => { }, onClose = () => { }, toggleDrawer = () => { } }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isCategoryOpen, setCategoryOpen] = useState(true);
  const [placeName, setPlaceName] = useState([]);
  const [placeCoordinate, setPlaceCoordinate] = useState("");
  const [selected, setSelected] = useState();

  const { suggestions, fetchSuggestionLoading: loading } = useSelector(
    (state) => state.map
  );
  useEffect(() => {
    if (selected) {
      dispatch(
        searchNearByStart({
          placeName: placeName.label,
          category: selected,
        })
      );
    }
  }, [selected]);

  const handleSearch = () => {
    console.log("service", placeName)
    if (placeName) {
      dispatch(
        searchNearByStart({
          placeName: placeName.label,
          category: selected,
        })
      );

      dispatch(
        setServiceName({
          placeName
        })
      );
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          backgroundColor: colors.common.white,
          gap: 1,
          boxShadow: 1,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            borderRadius: 1,
            gap: 1,
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton size="large" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
            <Box width="1px" height="30px" bgcolor={colors.grey[400]} />
          </Box>
          <Box
            width="100%"
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "15px",
              paddingBottom: "10px",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "15px",
                  marginLeft: "10px",
                }}
              >
                  {t('Find Nearby')}
              </Typography>
              <IconButton
                size="small"
                sx={{
                  marginRight: "10px",
                }}
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Autocomplete
              options={suggestions}
              loading={loading}
              popupIcon={false}
              filterOptions={(option) => option}
                renderOption={(props, option) => {
              let subtitle = '';
              if (option.type === 'city_name') {
                subtitle = 'City';
              } else if (option.type === 'region') {
                subtitle = 'Region';
              } else {
                const city = option.city_name || '';
                const region = option.region || '';
                if (city && region) {
                  subtitle = ` ${region} Region,${city} City`;
                } 
                else if (city) {
                  subtitle = `${city}, City`;
                } else if (region) {
                  subtitle = `${region} Region`;
                }
              }
              return (
                <li {...props} key={option.id}>
                  <Box>
                    <Typography variant="body1">{option.label}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {subtitle}
                    </Typography>
                  </Box>
                </li>
              );
            }}

              onChange={(_, value) =>
                value && setPlaceName(value)}
              onInputChange={async (_, value, reason) => {
                if (reason === "input") {

                  dispatch(suggestionFetchStart({ name: value }));
                }
              }}
              renderInput={(params) => (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <LocationOnOutlinedIcon
                    sx={{
                      color: colors.grey[600],
                      mr: "2px",
                    }}
                  />
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder={t('Enter place')}
                    sx={{
                      width: "100%",
                      mr: "20px",
                    }}
                    size="small"
                  />
                </Box>
              )}
            />
            <Button
              variant="outlined"
              color="primary"
              sx={{
                mr: "20px",
                ml: "10px",
                mt: "5px",
                mb: "10px",
              }}
              size="small"
              onClick={handleSearch}
            >
              {t('Search')}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: isCategoryOpen ? "block" : "none",
        }}
      >
        <Category
          title={t('Find Nearby Facilities')}
          selected={selected}
          onSelect={(category) => setSelected(category)}
          onClose={() => setCategoryOpen(false)}
          setActiveTab={setActiveTab}
        />
      </Box>
    </Box>
  );
};
